import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

export const fetchDashboardStats = createAsyncThunk(
  'dashboard/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const [products, users, businesses, enquiries, comparison] = await Promise.all([
        axios.get('/admin/dashboard/products'),
        axios.get('/admin/dashboard/users'),
        axios.get('/admin/dashboard/businesses'),
        axios.get('/admin/dashboard/enquiries'),
        axios.get('/admin/dashboard/comparison')
      ]);

      return {
        totalProducts: products.data,
        totalUsers: users.data,
        totalBusinesses: businesses.data,
        totalEnquiries: enquiries.data,
        comparisonData: comparison.data
      };


    } catch (error) {
      return rejectWithValue(error.response?.data?.msg || 'Failed to fetch dashboard stats');
    }
  }
);

const initialState = {
  stats: {
    totalProducts: 0,
    totalUsers: 0,
    totalBusinesses: 0,
    totalEnquiries: 0,
    comparisonData: []
  },


  isLoading: false,
  error: null
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.isLoading = false;
        state.stats = action.payload;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export default dashboardSlice.reducer;
